@if (isPostponed()) {
    <app-info-banner [title]="'Opgeschort tot ' + postponedTill().toLowerCase() + (postponedBy() ? '' : '.')" class="card-banner" tone="warn">
        @if (postponedBy()) {
            door {{ postponedBy() }}.
        }
        Er worden geen meldingen verstuurd.
        <span actions><ng-content select="[resume]"></ng-content></span>
    </app-info-banner>
}
@if (failure(); as f) {
    <app-info-banner [title]="(f.since ? 'Storing sinds ' + f.since : 'Storing') + ':'" class="card-banner" tone="error">
        @if (f.cause) {
            {{ f.cause }}.
        } @else {
            de laatste check is mislukt.
        }
        @if (f.count > 1) {
            {{ f.count }} checks achter elkaar mislukt.
        }
    </app-info-banner>
}

<div class="title-area d-flex flex-wrap align-items-start gap-3">
    <div class="title-main d-flex flex-column gap-1 flex-grow-1">
        <a class="eyebrow" routerLink="/{{Routenames.platforms}}/{{platform().id}}">{{ platform().name }}</a>
        <div class="d-flex flex-wrap align-items-center gap-3">
            <h1>{{ checkpoint().name }}</h1>
            @if (status(); as s) {
                <app-status-badge [tone]="s.tone">{{ s.label }}</app-status-badge>
            }
        </div>
        @if (checkpoint().url) {
            <a class="url" href="{{checkpoint().url}}" id="checkpoint-{{checkpoint().id}}" target="_blank">
                {{ checkpoint().url | urlPrefixStripping }}
                <i class="fa-regular fa-arrow-up-right-from-square"></i>
            </a>
        }
    </div>
    <div class="d-flex flex-wrap gap-2">
        <ng-content select="[actions]"></ng-content>
        @if (Features.CheckpointsSave | hasFeature) {
            <a mat-stroked-button routerLink="/{{Routenames.seire}}/{{platform().id}}/store/{{checkpoint().id}}">
                <i class="fa-regular fa-pen me-1"></i> Bewerken
            </a>
        }
    </div>
</div>

@if (config(); as c) {
    <div class="config">
        <div class="cell">
            <span class="label">Niveau</span>
            <span class="value">{{ c.level }}</span>
            <span class="help">Omgeving</span>
        </div>
        <div class="cell">
            <span class="label">Verwachte statuscode</span>
            <span class="value">{{ c.responseCode }}</span>
            <span class="help">{{ c.responseHelp }}</span>
        </div>
        <div class="cell">
            <span class="label">Opnieuw proberen</span>
            <span class="value">{{ c.retries }}</span>
            <span class="help">Bij een mislukte check</span>
        </div>
        <div class="cell">
            <span class="label">Interval</span>
            <span class="value">{{ c.interval }}</span>
            <span class="help">Hoe vaak gecontroleerd</span>
        </div>
        <div class="cell">
            <span class="label">SSL verloopt</span>
            @if (!c.sslChecked) {
                <span class="value">—</span>
                <span class="help">Niet gecontroleerd</span>
            } @else if (checkpoint().ssl_valid_till) {
                <span [class]="c.sslTone" class="value">{{ checkpoint().ssl_valid_till | daysFromNow }}</span>
                <span class="help">{{ checkpoint().ssl_valid_till | date: 'd MMM yyyy' }}</span>
            } @else {
                <span class="value">—</span>
                <span class="help">Nog niet bekend</span>
            }
        </div>
        <div class="cell">
            <span class="label">Opgeschort tot</span>
            <span class="value">{{ c.postponedTill }}</span>
            <span class="help">{{ c.postponedHelp }}</span>
        </div>
    </div>
}
